
import Modal from 'react-bootstrap/Modal';

function CustomModal({ showModal, handleClose, children }) {

    return (
        <>


            <Modal
                show={showModal}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
            >
                {
                    children
                }
                {/* <Modal.Header closeButton>
                    <Modal.Title>Delete Modal</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure to remove "{data?.trackingStatus ? data?.trackingStatus : data?.name}" ?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                    <Button disabled={loading} variant="primary" onClick={handleSubmit}>Confirm</Button>
                </Modal.Footer> */}
            </Modal>
        </>
    );
}

export default CustomModal;